<template>
  <div class="c-app-content">
    <div class="c-app-title">
      <div>
        <h1>
          <img class="c-app-title__icon" src="../../assets/images/icons/icon24-opportunities-primary.svg"
               alt="opportunities">{{ $t('report') }}
        </h1>
        <p class="c-app-title__back"><router-link to="/report"><i class="fa fa-long-arrow-left"></i>{{ $t('summary') }}</router-link></p>
      </div>
      <ul class="c-app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Callio</router-link></li>
        <li class="breadcrumb-item"><router-link to="/report">{{ $t('reports') }}</router-link></li>
        <li class="breadcrumb-item active">{{ $t('patient') }}</li>
      </ul>
    </div>
    <div class="tile">
      <div class="c-action">
        <div class="row">
          <div class="col-lg-2 c-action__left"><span class="c-action__title">Thống kê bệnh nhân</span></div>
          <div class="col-lg-10 c-action__right">
            <user-group-select :model="filterFormModel" attribute="group" is-filter @change="load" v-if="$store.state.user.role === 'owner'"></user-group-select>
            <dropdown :model="filterFormModel" attribute="groupBy" :right-menu="true" label="Nhóm theo"
                      type="bordered" icon="fa fa-list" :options="[
                        {value: 'group', text: 'Nhóm'},
                        {value: 'bacsy', text: 'Bác sỹ'},
                        {value: 'tnv', text: 'TNV'},
                      ]" @change="load">
            </dropdown>
            <time-range-picker :model="filterFormModel" @change="load" :label="$t('time')"
                               :defaultShortcut="8"></time-range-picker>
            <dropdown :model="filterFormModel" attribute="timeBy" :right-menu="true" label="Thời gian theo"
                      type="bordered" icon="fa fa-list" :options="[
                        {value: 'createdTime', text: 'Ngày tạo'},
                        {value: 'updatedTime', text: 'Ngày cập nhật'},
                      ]" @change="load">
            </dropdown>
            <button class="btn btn-sm btn-primary" @click="load"><i class="fa fa-refresh mr-0"></i></button>
          </div>
        </div>
        <!-- <div class="row">
            <div class="col-lg-10 c-action__left"></div>
            <div class="col-lg-2 c-action__right">
                <call-export :data="data" :filter="filterFormModel"></call-export>
            </div>
        </div> -->
      </div>
      <div class="col" v-if="loading">
        <skeleton-loading>
          <row>
            <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
          </row>
          <row>
            <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
          </row>
        </skeleton-loading>
      </div>
      <div v-else class="tile-body">
        <div class="tile shadow c-report-total">
          <div class="tile-body">
            <div class="row">
              <div class="col-sm-6 col-lg-2 text-center">
                <p class="mb-1">Tất cả</p>
                <h2 class="mb-3 mb-lg-0">{{ sum.total }}</h2>
              </div>
              <div class="col-sm-6 col-lg-2 text-center">
                <p class="mb-1">Chưa phân công</p>
                <h2 class="mb-3 mb-lg-0">{{ sum.notAssigned }}</h2>
              </div>
              <div class="col-sm-6 col-lg-2 text-center">
                <p class="mb-1">Chưa sàng lọc</p>
                <h2 class="mb-3 mb-lg-0">{{ sum.new }}</h2>
              </div>
              <div class="col-sm-6 col-lg-2 text-center">
                <p class="mb-1">Đã sàng lọc</p>
                <h2 class="mb-3 mb-lg-0">{{ sum.ncx }}</h2>
              </div>
              <div class="col-sm-6 col-lg-2 text-center">
                <p class="mb-1">NC3</p>
                <h2 class="mb-3 mb-lg-0">{{ sum.nc3 }}</h2>
              </div>
              <div class="col-sm-6 col-lg-2 text-center">
                <p class="mb-1">NC4</p>
                <h2 class="mb-3 mb-lg-0">{{ sum.nc4 }}</h2>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-12">
            <div class="tile shadow">
              <h3 class="tile-title">Bệnh nhân</h3>
              <apexchart :height="300" :options="chartOptions" :series="chartData"></apexchart>
            </div>
          </div>
        </div>
        <div class="table-responsive c-template-table">
          <table class="table table-hover">
            <thead>
            <tr>
              <th></th>
              <th></th>
              <th v-if="filterFormModel.groupBy === 'group'" class="text-center">Số bác sỹ</th>
              <th v-if="filterFormModel.groupBy === 'group'" class="text-center">Số TNV</th>
              <th v-if="filterFormModel.groupBy === 'group'" class="text-center">Số BN/ bác sỹ</th>
              <th v-if="filterFormModel.groupBy === 'group'" class="text-center">Số BN đã sàng lọc/ bác sỹ</th>
              <th v-if="filterFormModel.groupBy === 'group'" class="text-center">Số NC3/ bác sỹ</th>
              <th v-if="filterFormModel.groupBy === 'group'" class="text-center">Số NC4/ bác sỹ</th>
              <th class="text-center">Tổng</th>
              <th v-if="filterFormModel.groupBy === 'group'" class="text-center">Chưa phân công</th>
              <th class="text-center">Đã phân công</th>
              <th class="text-center">Chưa sàng lọc</th>
              <th class="text-center">Đã sàng lọc</th>
              <th class="text-center">NC0</th>
              <th class="text-center">NC1</th>
              <th class="text-center">NC2</th>
              <th class="text-center">NC3</th>
              <th class="text-center">NC4</th>
              <th v-if="filterFormModel.groupBy === 'bacsy'" class="text-center">Đang chăm sóc</th>
              <th class="text-center">Đã khỏi bệnh</th>
              <th class="text-center">Ngừng theo dõi</th>
              <th class="text-center">Lỗi</th>
            </tr>
            </thead>
            <tbody>
            <tr class="bg-green-light">
              <td></td>
              <td><b class="text-uppercase">{{ $t('totals') }}</b></td>
              <td v-if="filterFormModel.groupBy === 'group'" class="text-center">{{sum.bs}}</td>
              <td v-if="filterFormModel.groupBy === 'group'" class="text-center">{{sum.tnv}}</td>
              <td v-if="filterFormModel.groupBy === 'group'" class="text-center">{{sum.total / sum.bs | numFormat('0.0')}}</td>
              <td v-if="filterFormModel.groupBy === 'group'" class="text-center">{{sum.ncx / sum.bs | numFormat('0.0')}}</td>
              <td v-if="filterFormModel.groupBy === 'group'" class="text-center">{{sum.nc3 / sum.bs | numFormat('0.0')}}</td>
              <td v-if="filterFormModel.groupBy === 'group'" class="text-center">{{sum.nc4 / sum.bs | numFormat('0.0')}}</td>
              <td class="text-center"><span class="text-blue">{{ sum.total }}</span></td>
              <td v-if="filterFormModel.groupBy === 'group'" class="text-center"><span class="text-blue">{{ sum.notAssigned }} {{getPercent(sum.notAssigned, sum.total)}}</span></td>
              <td class="text-center"><span class="text-blue">{{ sum.assigned }} {{getPercent(sum.assigned, sum.total)}}</span></td>
              <td class="text-center"><span class="text-blue">{{ sum.new }} {{getPercent(sum.new, sum.total)}}</span></td>
              <td class="text-center"><span class="text-blue">{{ sum.ncx }} {{getPercent(sum.ncx, sum.total)}}</span></td>
              <td class="text-center"><span class="text-blue">{{ sum.nc0 }} {{getPercent(sum.nc0, sum.ncx)}}</span></td>
              <td class="text-center"><span class="text-blue">{{ sum.nc1 }} {{getPercent(sum.nc1, sum.ncx)}}</span></td>
              <td class="text-center"><span class="text-blue">{{ sum.nc2 }} {{getPercent(sum.nc2, sum.ncx)}}</span></td>
              <td class="text-center"><span class="text-blue">{{ sum.nc3 }} {{getPercent(sum.nc3, sum.ncx)}}</span></td>
              <td class="text-center"><span class="text-blue">{{ sum.nc4 }} {{getPercent(sum.nc4, sum.ncx)}}</span></td>
              <td v-if="filterFormModel.groupBy === 'bacsy'" class="text-center">{{ sum.takingCare }}</td>
              <td class="text-center">{{ sum.recovered }}</td>
              <td class="text-center">{{ sum.stopFollow }}</td>
              <td class="text-center">{{ sum.fault }}</td>
            </tr>
            <tr :key="index" v-for="(item, index) in data">
              <td class="text-center">{{ index + 1 }}</td>
              <td style="min-width: 200px"><b>{{item.label}}</b></td>
              <td v-if="filterFormModel.groupBy === 'group'" class="text-center">{{item.bs}}</td>
              <td v-if="filterFormModel.groupBy === 'group'" class="text-center">{{item.tnv}}</td>
              <td v-if="filterFormModel.groupBy === 'group'" class="text-center">{{item.total / item.bs | numFormat('0.0')}}</td>
              <td v-if="filterFormModel.groupBy === 'group'" class="text-center">{{item.ncx / item.bs | numFormat('0.0')}}</td>
              <td v-if="filterFormModel.groupBy === 'group'" class="text-center">{{item.nc3 / item.bs | numFormat('0.0')}}</td>
              <td v-if="filterFormModel.groupBy === 'group'" class="text-center">{{item.nc4 / item.bs | numFormat('0.0')}}</td>
              <td class="text-center"><span class="text-blue">{{ item.total }}</span></td>
              <td v-if="filterFormModel.groupBy === 'group'" class="text-center"><span class="text-blue">{{ item.notAssigned }} {{getPercent(item.notAssigned, item.total)}}</span></td>
              <td class="text-center"><span class="text-blue">{{ item.assigned }} {{getPercent(item.assigned, item.total)}}</span></td>
              <td class="text-center"><span class="text-blue">{{ item.new }} {{getPercent(item.new, item.total)}}</span></td>
              <td class="text-center"><span class="text-blue">{{ item.ncx }} {{getPercent(item.ncx, item.total)}}</span></td>
              <td class="text-center"><span class="text-blue">{{ item.nc0 }} {{getPercent(item.nc0, item.ncx)}}</span></td>
              <td class="text-center"><span class="text-blue">{{ item.nc1 }} {{getPercent(item.nc1, item.ncx)}}</span></td>
              <td class="text-center"><span class="text-blue">{{ item.nc2 }} {{getPercent(item.nc2, item.ncx)}}</span></td>
              <td class="text-center"><span class="text-blue">{{ item.nc3 }} {{getPercent(item.nc3, item.ncx)}}</span></td>
              <td class="text-center"><span class="text-blue">{{ item.nc4 }} {{getPercent(item.nc4, item.ncx)}}</span></td>
              <td v-if="filterFormModel.groupBy === 'bacsy'" class="text-center">{{ item.takingCare }}</td>
              <td class="text-center">{{ item.recovered }}</td>
              <td class="text-center">{{ item.stopFollow }}</td>
              <td class="text-center">{{ item.fault }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import TimeRangePicker from "../../components/TimeRangePicker";
import VueApexCharts from 'vue-apexcharts';
import UserGroupSelect from '@/components/UserGroupSelect';
import Dropdown from "@/components/Dropdown";

export default {
  components: {
    TimeRangePicker,
    UserGroupSelect,
    Dropdown,
    'apexchart': VueApexCharts,
    // CallExport
  },
  data() {
    return {
      filterFormModel: {
        group: ['bac-sy-truong-nhom', 'bac-sy-pho-nhom', 'bac-sy', 'nvyt'].includes(this.$store.state.user.role) ? this.$store.state.user.group : null,
        groupBy: ['bac-sy-truong-nhom', 'bac-sy-pho-nhom', 'bac-sy', 'nvyt'].includes(this.$store.state.user.role) ? 'bacsy' : 'group'
      },
      loading: true,
      sum: {},
      data: [],
      chartOptions: {},
      chartData: []
    }
  },
  methods: {
    getPercent(pEarned, pPos) {
      if(pEarned === 0 || pPos === 0) {
        return '';
      }
      let p = ((pEarned/pPos) * 100).toFixed(2);
      return `(${p}%)`;
    },
    load() {
      this.loading = true;
      // this.filterFormModel.to = moment(this.filterFormModel.to, 'x').endOf('day').format('x');
      this.$service.get('/report/patient', {
        params: this.filterFormModel
      }).then(response => {
        this.data = response.data;
        this.sum = {};
        this.data.forEach(item => {
          for (let key in item) {
            if (!this.sum[key]) {
              this.sum[key] = 0;
            }
            this.sum[key] += item[key];
          }
        });
        this.chartOptions = {
          chart: {
            type: 'donut'
          },
          labels: [
            `NC0: ${this.sum.nc0}`,
            `NC1: ${this.sum.nc1}`,
            `NC2: ${this.sum.nc2}`,
            `NC3: ${this.sum.nc3}`,
            `NC4: ${this.sum.nc4}`,
            `Chưa sàng lọc: ${this.sum.new}`
          ]
        };
        this.chartData = [this.sum.nc0, this.sum.nc1, this.sum.nc2, this.sum.nc3, this.sum.nc4, this.sum.new]
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>